import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.masterdetail = {
    init: function(elt, va, allbindings, model, context) {
        var new_model = {};
        var items= ko.unwrap(va());

        $.extend(new_model,  {
            items: va(),
            editable: allbindings().editable,
            selectItem: function(item) {
                console.log("select:", arguments);
                new_model.selectedItem(null);
                new_model.selectedItem(item);
            },
            selectedItem: ko.observable(items && items.length ? items[0] : null),
            deleteItem: function(item) {
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if (idx < 0)
                        item = null;
                }
                if (!item)
                    item = new_model.selectedItem();
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if(idx>=0) {
                        new_model.items.splice(idx, 1);
                    }
                    if (idx > 0) {
                        idx = idx - 1;
                    }
                    if (idx <= new_model.items().length) {
                        new_model.selectedItem(new_model.items()[idx]);
                    } else {
                        new_model.selectedItem(null);
                    }
                }
            },
            createItem: function() {
                var items = va();
                var new_data = ko.toJS(context.blank_data);
                var guids = [];
                var promises = [];
                ["id", "unique_id", "_unique_id", "upload_id", "uploads_id", "media_box_id"].forEach((k) => {
                    if (typeof new_data[k] !== "undefined" && new_data[k] !== null && new_data[k].replace) {
                        promises.push(uly.utils.str_replace_async(new_data[k], "#newguid#", ()=> { return uly.utils.new_guid(); })
                            .then((res) => { new_data[k] = res; }));
                    } 
                });
                Promise.all(promises).then(()=>{
                    var new_item = ko.mapping.fromJS($.extend({}, new_data));
                    items.push(new_item);
                    new_model.selectItem(new_item);
                });
            },
            canItemMoveUp: function(item) {
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if (idx < 0)
                        item = null;
                }
                var sitem = item;
                if (!item)
                    sitem = ko.unwrap(new_model.selectedItem);
                if (!sitem) return false;
                var items = ko.unwrap(va());
                if (!items) return false;
                return items.indexOf(sitem) > 0;
            },
            canMoveUp: ko.pureComputed(function() {
                var sitem = ko.unwrap(new_model.selectedItem);
                if (!sitem) return false;
                var items = ko.unwrap(va());
                if (!items) return false;
                return items.indexOf(sitem) > 0;
            }),
            moveUp: function(item) {
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if (idx < 0)
                        item = null;
                }
                if (!item)
                    item = new_model.selectedItem();
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if(idx > 0) {
                        new_model.selectedItem(null);
                        new_model.items.splice(idx, 1);
                        new_model.items.splice(idx-1, 0, item);
                        new_model.selectedItem(item);
                    }
                }

            },
            canItemMoveDown: function(item) {
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if (idx < 0)
                        item = null;
                }
                var sitem = item;
                if (!item)
                    sitem = ko.unwrap(new_model.selectedItem);
                if (!sitem) return false;
                var items = ko.unwrap(va());
                if (!items) return false;
                return items.indexOf(sitem) < items.length - 1;
            },
            canMoveDown: ko.pureComputed(function() {
                var sitem = ko.unwrap(new_model.selectedItem);
                if (!sitem) return false;
                var items = ko.unwrap(va());
                if (!items) return false;
                return items.indexOf(sitem) < items.length - 1;
            }),
            moveDown: function(item) {
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if (idx < 0)
                        item = null;
                }
                if (!item)
                    item = new_model.selectedItem();
                if (item) {
                    var idx = ko.unwrap(new_model.items).indexOf(item);
                    if(idx < new_model.items().length - 1) {
                        new_model.selectedItem(null);
                        new_model.items.splice(idx, 1);
                        new_model.items.splice(idx+1, 0, item);
                        new_model.selectedItem(item);
                    }
                }
            }
        });
        var childContext = context.createChildContext(new_model);
        ko.applyBindingsToDescendants(childContext, elt);
        return { controlsDescendantBindings: true };

    }
};
